/**
 * 网站基本设置
 */
let baseInfo = {
  webSoketDomain: "http://gzh.bpvote.com"
};
// 开发环境
if (process.env.NoDe_ENV === "development") {
  baseInfo.webSoketDomain = "http://192.168.1.248:8080/";
}
export { baseInfo };
